// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import "./Search_Results.css"; // Create this file for styling

// function SearchResults() {
// const location = useLocation();
// const query = new URLSearchParams(location.search).get("q");
// const [results, setResults] = useState([]);
// const [loading, setLoading] = useState(true);

// useEffect(() => {
//     if (query) {
//     setLoading(true);
    
//       // Simulate a search API call
//     setTimeout(() => {
//         // Example mock results based on the topics from your navbar
//         const mockResults = [
//         {
//             id: 1,
//             title: `${query} in History & Society`,
//             category: "History & Society",
//             description: `Explore the historical significance and societal impact of ${query}.`,
//             url: `/history-society/${query.toLowerCase().replace(/\s+/g, '-')}`
//         },
//         {
//             id: 2,
//             title: `Scientific aspects of ${query}`,
//             category: "Science & Tech",
//             description: `Learn about the scientific principles and technological applications related to ${query}.`,
//             url: `/science-tech/${query.toLowerCase().replace(/\s+/g, '-')}`
//         },
//         {
//             id: 3,
//             title: `Notable figures related to ${query}`,
//             category: "Biographics",
//             description: `Discover important people who have significantly contributed to the field of ${query}.`,
//             url: `/biographics/${query.toLowerCase().replace(/\s+/g, '-')}`
//         }
//         ];
        
//         setResults(mockResults);
//         setLoading(false);
//     }, 500);
//     }
// }, [query]);

// if (!query) {
//     return <div className="search-results-container"><h1>Please enter a search term</h1></div>;
// }

// return (
//     <div className="search-results-container">
//     <h1>Search Results for: "{query}"</h1>
    
//     {loading ? (
//         <div className="loading">Loading results...</div>
//     ) : results.length === 0 ? (
//         <div className="no-results">
//         <p>No results found for "{query}". Try different keywords or explore our topic categories.</p>
//         <div className="topic-suggestions">
//             <h3>Popular Topics</h3>
//             <div className="topic-buttons">
//             <a href="/history-society">History & Society</a>
//             <a href="/science-tech">Science & Tech</a>
//             <a href="/biographics">Biographics</a>
//             <a href="/animals-nature">Animals & Nature</a>
//             </div>
//         </div>
//         </div>
//     ) : (
//         <div className="results-list">
//         {results.map(result => (
//             <div key={result.id} className="result-item">
//             <h2><a href={result.url}>{result.title}</a></h2>
//             <span className="result-category">{result.category}</span>
//             <p>{result.description}</p>
//             <a href={result.url} className="read-more">Read more</a>
//             </div>
//         ))}
//         </div>
//     )}
//     </div>
// );
// }

// export default SearchResults;

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/Search_Results.css';

const SearchResults = ({ allTalkShows = [] }) => {
const [searchResults, setSearchResults] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [isSearching, setIsSearching] = useState(false);
const location = useLocation();

useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const query = searchParams.get('q') || '';
    
    if (query.trim()) {
    setSearchTerm(query);
    setIsSearching(true);
    performSearch(query);
    } else {
    setSearchTerm('');
    setIsSearching(false);
    setSearchResults([]);
    }
}, [location.search, allTalkShows]);

const performSearch = (query) => {
    const trimmedQuery = query.trim().toLowerCase();
    
    if (!trimmedQuery) {
    setSearchResults([]);
    return;
    }

    // Filter talk shows based on the search query
    const filteredResults = allTalkShows.filter(show => {
    return (
        show.title?.toLowerCase().includes(trimmedQuery) ||
        show.description?.toLowerCase().includes(trimmedQuery) ||
        show.host?.toLowerCase().includes(trimmedQuery) ||
        show.guests?.some(guest => guest.toLowerCase().includes(trimmedQuery)) ||
        show.topics?.some(topic => topic.toLowerCase().includes(trimmedQuery))
    );
    });

    setSearchResults(filteredResults);
};

  // If not searching, don't render anything
if (!isSearching) {
    return null;
}

return (
    <div className="search-results-container">
    <div className="search-header">
        <h2>Search Results for "{searchTerm}"</h2>
        <p>{searchResults.length} result{searchResults.length !== 1 ? 's' : ''} found</p>
    </div>

    {searchResults.length === 0 ? (
        <div className="no-results1">
        <div className="no-results-icon">🔍</div>
        <h3>No results found</h3>
        <p>Sorry, we couldn't find any talk shows matching your search term "{searchTerm}".</p>
        <div className="no-results-suggestions">
            <h4>Try:</h4>
            <ul>
                <li>Checking your spelling</li>
                <li>Using different keywords</li>
                <li>Using more general terms</li>
                <li>Browsing our featured talk shows instead</li>
            </ul>
        </div>
        </div>
    ) : (
        <div className="search-results-grid">
        {searchResults.map((show, index) => (
            <div key={index} className="search-result-card">
            <div className="search-result-header">
                <h3>{show.title}</h3>
                <span className="search-result-date">{show.date}</span>
            </div>
            
            {show.host && (
                <p className="search-result-host">
                <strong>Host:</strong> {show.host}
                </p>
            )}
            
            {show.guests && show.guests.length > 0 && (
                <p className="search-result-guests">
                <strong>Guests:</strong> {show.guests.join(', ')}
                </p>
            )}
            
            {show.description && (
                <p className="search-result-description">
                {show.description.length > 150 
                    ? `${show.description.substring(0, 150)}...` 
                    : show.description
                }
                </p>
            )}
            
            {show.topics && show.topics.length > 0 && (
                <div className="search-result-topics">
                {show.topics.map((topic, topicIndex) => (
                    <span key={topicIndex} className="topic-tag">
                    {topic}
                    </span>
                ))}
                </div>
            )}
            
            <button className="watch-button">Watch Now</button>
            </div>
        ))}
        </div>
    )}
    </div>
);
};

export default SearchResults;